export default __webpack_public_path__ + "static/media/alyssa.4dfbb190.jpg";